import { connect } from 'react-redux';
import withLocalLoader from '../../components/HOCs/withLocalLoader';
import DashboardCommissions from './DashboardCommissions';

export default connect(null)(
  withLocalLoader(
    DashboardCommissions,
    false,
    'CustomersCommissions',
    'CustomersCommissions'
  )
);
